import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { getBusinessPlan, getRole } from 'constants/localStorageManager';
import { USERS } from 'constants/Users';

const AddonsBanner = ({ addonActive }) => {
  const userPlan = getBusinessPlan();
  const isProPlan = userPlan.title === 'pro';
  const isEssentialPlan = userPlan.title === 'essential';
  const isSuperAdmin = getRole() === USERS.ADMIN;

  if (!(isProPlan || isEssentialPlan || isSuperAdmin)) {
    return (
      <Card className="styled-box-shadow bg-light addon-banner mt-3 ml-3 px-3 pt-3">
        <p>
          <FontAwesomeIcon icon="exclamation-triangle" />
          Growth Add-Ons are only available with a Pro Subscription
        </p>
      </Card>
    );
  }

  if (!addonActive) {
    return (
      <Card className="styled-box-shadow bg-light mt-3 ml-3 px-3 pt-3">
        <p className="d-flex flex-row addon-banner">
          <FontAwesomeIcon icon="exclamation-triangle" />
          You are not ready to use Growth Add-ons. Finish publishing your
          Survey, then click Add-Ons in the menu bar to configure your Growth
          Add-Ons.
        </p>
      </Card>
    );
  }

  return null;
};

AddonsBanner.defaultProps = {
  addonActive: false,
};

AddonsBanner.propTypes = {
  addonActive: PropTypes.bool,
};

export default AddonsBanner;



// WEBPACK FOOTER //
// ./src/components/Banners/customSurveyAddOn.js